import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import more from "@/more/more";
import signUp from "@/signUp/signUp";
import signUpBody from "@/signUpBody/signUpBody";
import login from "@/login/login";
import register from "@/register/register";
import forget from "@/forget/forget";
import signUpForm from "@/signUpForm/signUpForm";
import setHotel from "@/setHotel/setHotel";
import signUpLoad from "@/signUpLoad/signUpLoad";
import signUpInformation from "@/signUpInformation/signUpInformation";
import person from "@/person/person";
import hotel from "@/personComponents/hotel";
import paper from "@/personComponents/paper";
import sign from "@/personComponents/sign";
import paperUpload from "@/personComponents/paperUpload";
// import signUpInformation1 from "@/signUpInformation/signUpInformation1.vue";

Vue.use(VueRouter)

const routes = [
  {path: '/', redirect: '/signup'},
  // {path: '/home', name: 'Home', component: Home},
  // {path: '/more', name: 'more', component: more},
  {path: '/login', name: 'login', component: login},
  {path: '/register', name: 'register', component: register},
  {path: '/forget', name: 'forget', component: forget},
  {path: '/setHotel', name: 'setHotel', component: setHotel},
  { path: '/signUpLoad', component: signUpLoad },
  { path: '/paperUpload', component: paperUpload },
  { path: '/person', component: person,redirect: '/person/paper',
    children: [
      { path: '/person/hotel', component: hotel },
      { path: '/person/paper', component: paper },
      { path: '/person/sign', component: sign },
    ]
  },
  {path: '/signup', name: 'signUp', component: signUp, redirect: '/signUp/signUpInformation',
    children: [
      { path: '/signUp/signUpBody', component: signUpBody },
      { path: '/signUp/signUpInformation', component: signUpInformation },
      ]
  },
  {path: '/signUpForm', component: signUpForm },

]

const router = new VueRouter({
  routes,
  // mode:'history',
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 从哪个路径跳转
  // next 是一个函数，表示放行
  // next() 放行 next('/login') 强制跳转
  if (to.path === '/login'){
    // window.localStorage.clear()
    // window.sessionStorage.clear()
    next()
  }
  // 如果访问的是'login'页面直接放行
  if (to.path === '/register') return next()
  if (to.path === '/forget') return next()
  // 如果不是访问的'/login'，获取token
  // const tokenstr = window.sessionStorage.getItem('token')
  // // 如果没有获取到 token 返回 'login'，如果获取到了直接 next()
  // if (!tokenstr) return next('/login')
  next()
})

export default router
